import { i18n } from '@/i18n'

export function formatStatus(status, prefix = 'store_list_page', vm) {
  if (status === null || status === undefined || status === '') return '-'
  const strStatus = String(status).trim()
  const lowerStatus = strStatus.toLowerCase()
  const key = `${prefix}.${lowerStatus}`

  const inst = vm || i18n

  if (inst && typeof inst.$te === 'function') {
    if (inst.$te(key)) {
      const translated = inst.$t(key)
      if (translated && translated !== key) {
        return translated
      }
    }
  } else if (inst && typeof inst.te === 'function') {
    if (inst.te(key)) {
      const translated = inst.t(key)
      if (translated && translated !== key) {
        return translated
      }
    }
  }

  return lowerStatus
    .split('_')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
